export default "__VITE_ASSET__DplEs8Qa__"